import { useNavigation } from "@/contexts/NavigationContext";
import { cn } from "@/lib/utils";

interface NavigationLoaderProps {
  isMobile?: boolean;
}

export const NavigationLoader = ({ isMobile }: NavigationLoaderProps) => {
  const { isNavigating, targetLabel } = useNavigation();

  if (!isNavigating) return null;

  return (
    <div className={cn(
      "z-50 flex items-center justify-center bg-background/95 backdrop-blur-sm animate-fade-in",
      isMobile 
        ? "fixed top-14 left-0 right-0 bottom-16" // Between TopBar and BottomNav
        : "absolute inset-0"
    )}>
      <div className="flex flex-col items-center gap-4">
        {/* Pulsing dots */}
        <div className="flex items-center gap-2">
          {[0, 1, 2].map((i) => (
            <div
              key={i}
              className={cn(
                "h-3 w-3 rounded-full bg-primary",
                "animate-pulse"
              )}
              style={{
                animationDelay: `${i * 150}ms`,
                animationDuration: "0.8s",
              }}
            />
          ))}
        </div>
        
        {/* Loading text */}
        {targetLabel && (
          <p className="text-sm text-muted-foreground animate-pulse">
            Loading {targetLabel}...
          </p>
        )}
      </div>
    </div>
  );
};
